<template>
  <div
    class="calender-schedule-detail-preview-component"
    :class="{ 'single-image': images.length === 1 }"
  >
    <hi-dialog class="media-dialog" title="Media" @close="close()">
      <div class="main-view">
        <el-carousel
          v-model="currentIndex"
          @change="changeImageIndex"
          :arrow="arrow"
          :autoplay="false"
          :indicator-position="indicatorPosition"
          :height="containerHeight"
          trigger="click"
        >
          <el-carousel-item v-for="img in images" :key="img.url">
            <div
              style="
                border-bottom: 1px solid #e5e5e5;
                background: #e5e5e5;
                overflow: scroll;
              "
              ref="group"
              :style="{ height: containerHeight }"
            >
              <img
                v-show="img.type === 1"
                ondragstart="return false;"
                style="width: 375px"
                :src="img.url"
              />
              <tag-people-group
                :type="tagType"
                :readonly="true"
                class="tag-people"
                :image="img"
                :class="{ show: showTag }"
                v-show="hasTag"
              ></tag-people-group>
              <div
                class="tag-mask"
                @click="show = !show"
                v-show="hasTag(img)"
              ></div>
              <hi-video v-if="img.type === 2" :src="img.url"></hi-video>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!--当video 没有user tag 就不显示下滑下了-->
        <div
          class="video-tag-container"
          :class="{ 'more-media': images.length > 1 }"
          v-show="
            images[currentIndex].type === 2 &&
            images[currentIndex].usertags.length > 0
          "
        >
          <div class="tag-tip">Tag People</div>
          <div
            class="list-container"
            :class="{ 'no-top': images[currentIndex].usertags.length === 0 }"
          >
            <div
              class="tag-item"
              v-for="tag in images[currentIndex].usertags"
              :key="tag.user_id"
            >
              <div
                class="person-image"
                v-lazy:background-image="{
                  src: tag.profile_pic_url,
                  error: emptyTagImg,
                }"
                :key="tag.profile_pic_url"
              ></div>
              <div class="person-main-container">
                <div class="person-main-container">
                  <div class="username-container">
                    <div class="username">{{ tag.username }}</div>
                    <div class="approve-icon" v-show="tag.isVerified"></div>
                  </div>
                  <div class="des">{{ tag.full_name }}</div>
                </div>
              </div>
              <div class="del-btn" @click="removeTag(tag)"></div>
            </div>
          </div>
        </div>
      </div>
    </hi-dialog>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.calender-schedule-detail-preview-component {
  width: 375px;
  .media-dialog {
    height: 700px;
    .main-view {
      flex: 1;
      flex-direction: column;
      display: flex;
      overflow: scroll;
      .video-tag-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        &.more-media {
          border-top: solid 1px #e6e6e6;
        }
        .tag-tip {
          font-size: 14px;
          height: 44px;
          display: flex;
          padding-left: 20px;
          align-items: center;
          font-weight: 500;
        }
        .list-container {
          overflow-y: auto;
          flex: 1;
          .tag-item {
            display: flex;
            align-items: center;
            padding: 7px 15px;

            &:hover {
              background-color: rgba(230, 43, 85, 0.1);
            }

            .person-image {
              height: 40px;
              width: 40px;
              border-radius: 50%;
              background-size: contain;
            }

            .person-main-container {
              margin-left: 5px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              flex: 1;
              overflow: hidden;

              .username-container {
                display: flex;
                align-items: center;

                .username {
                  font-size: 14px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .approve-icon {
                  background-image: url("../../../../../public/images/schedule_posts/tag_people/approve@3x.png");
                  width: 12px;
                  height: 12px;
                  background-size: contain;
                  margin-left: 4px;
                  position: relative;
                }
              }

              .des {
                font-size: 12px;
                color: @font-color-gray;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
@import "../../../../assets/style/theme";

.el-carousel__button {
  width: 7px !important;
  height: 7px !important;
  border-radius: 50%;
  background-color: @color-primary !important;
}

.calender-schedule-detail-preview-component {
  .tag-group {
    position: absolute !important;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .tag-people {
    position: absolute !important;
    left: 0;
    top: 0;
    opacity: 0;
    &.show {
      opacity: 1;
    }
  }
  .tag-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 500;
  }
  &.single-image {
    .el-carousel__button {
      background: white !important;
    }
  }
}
</style>
<script>
import hiDialog from "../../../common/dialog/Index.vue";
import { imageLoad } from "../../../../utils/media";
import { showErrorMsg } from "../../../../utils/errors";
import hiVideo from "../../../common/media/Video";
import tagPeopleGroup from "../../../common/tag/Group";
import emptyTagImg from "../../../../../public/images/schedule_posts/tag_people/avatar_placeholder.png";
export default {
  name: "DetailPreviewComponent",
  components: { hiDialog, hiVideo, tagPeopleGroup },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    igTV: {
      type: Boolean,
      default: false,
    },
    story: {
      type: Boolean,
      default: false,
    },
    alwaysTags: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * 如果单图不显示切换样式
     */
    indicatorPosition() {
      if (this.images.length === 1) {
        return "none";
      } else {
        return "outside";
      }
    },
    /**
     * 判断tag 类型
     */
    tagType() {
      // 因为tag people 和 tag product冲突，所以如果有一张图片有people 或者product就能判断类型
      const hasPeople = this.images.findIndex((img) => img.usertags.length > 0);
      if (hasPeople !== -1) {
        return "people";
      }
      const hasProduct = this.images.findIndex(
        (img) => img.product_tags.length > 0
      );
      if (hasProduct !== -1) {
        return "product";
      }
      return "people";
    },
    containerWidth() {
      if (this.igTV) {
        return "329px";
      }
      return "375px";
    },
    /**
     * 计算容器高度
     */
    containerHeight() {
      if (this.igTV) {
        return "651px";
      }
      if (this.story) {
        return "667px";
      }
      return `${375 / this.ratio}px`;
    },
    /**
     * 如果图片就1张则不显示箭头
     */
    arrow() {
      if (this.images.length === 1) {
        return "never";
      } else {
        return "hover";
      }
    },
    showTag() {
      if (this.alwaysTags) {
        return true;
      } else {
        return this.show;
      }
    },
  },
  data() {
    return {
      currentIndex: 0, // 当前页码
      ratio: 1,
      emptyTagImg,
      show: false, // 是否展示tag标签
    };
  },
  methods: {
    /**
     * 该图片(或视频)是否显示tag样式
     */
    hasTag(img) {
      // 如果是频频则点击不弹窗
      if (img.type === 2) {
        return false;
      }
      // 只有usertag 和 tagproduct存在其中一个则支持切换
      const hasPeople = img.usertags.length > 0;
      const hasProduct = img.product_tags.length > 0;
      return hasPeople || hasProduct;
    },
    changeImageIndex(index) {
      this.currentIndex = index;
      // 切换图片
      this.show = false;
    },
    /**
     * 关闭点击事件
     */
    close() {
      this.$parent.closeAll();
      this.$parent.showPreviewModal = false;
    },
  },
  async created() {
    try {
      // 获取图片
      const coverUrl =
        this.$parent.postInfo.mediaUrl || this.$parent.postInfo.coverUrl;
      const image = new Image();
      image.src = coverUrl;
      // 获取图片宽高比
      await imageLoad({ image });
      // 计算图片宽高比
      this.ratio = image.width / image.height;
    } catch (e) {
      showErrorMsg(e);
    }
  },
};
</script>
